/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks(value) {
    if (!('ShopUrl' in value) || value['ShopUrl'] === undefined)
        return false;
    if (!('SupportUrl' in value) || value['SupportUrl'] === undefined)
        return false;
    if (!('HelpUrl' in value) || value['HelpUrl'] === undefined)
        return false;
    if (!('OnStartHookUrl' in value) || value['OnStartHookUrl'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ShopUrl': json['ShopUrl'],
        'SupportUrl': json['SupportUrl'],
        'HelpUrl': json['HelpUrl'],
        'OnStartHookUrl': json['OnStartHookUrl'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ShopUrl': value['ShopUrl'],
        'SupportUrl': value['SupportUrl'],
        'HelpUrl': value['HelpUrl'],
        'OnStartHookUrl': value['OnStartHookUrl'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks.js.map